import React from "react";
import MainMenu from "./MainMenu";
import {Avatar, Snackbar, Spinner} from "@vkontakte/vkui";
import * as constants from "../assets/constants";
import {Icon24Add} from "@vkontakte/icons";
class BaseComponent extends React.Component {
    state = {
        activeModal: null,
        modalHistory: [],
        disableModalBack: false,
        isOffline: false,
        base_url: constants.DEBUG ? constants.base_url_stage : constants.base_url_prod,
        url: constants.DEBUG ? constants.url_stage : constants.url_prod,
    }
    getUrlParameters = () => {
        let res = {}
        let sPageURL = window.location.search.substring(1)

        let sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;
        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');
            res[sParameterName[0]] = sParameterName[1] === undefined ? '' : decodeURIComponent(sParameterName[1])

        }
        return res;
    }

    constructor(props) {
        super(props);


        this.modalBack = () => {
            if (!this.state.disableModalBack) {
                this.setActiveModal(this.state.modalHistory[this.state.modalHistory.length - 2]);
            } else {
                window.postMessage('modalBack')
            }
        };


        this.ref = React.createRef();
        this.handleScroll = this.handleScroll.bind(this)
    }

    openLoadingNoty = (text, duration = 30000, hideSpinner = false) => {
        // if (this.state.snackbar) return;
        window.postMessage({type: 'success',text, duration, hideSpinner})
    }
    openErrorNoty = (text, duration = 2000) => {
        console.log(`Error: ${text}`)
        window.postMessage({type: 'error', text, timeout: duration})
    }

    MainMenu = () => {
        return <MainMenu
            setActiveModal={(e) => this.props.setActiveModal(e)}
            onStoryChange={(e) => this.props.onStoryChange(e)}
            setActiveStory={(e) => this.props.setActiveStory(e)}
            current_user={this.props.current_user}
            setState={(state) => this.props.setState(state)}
            doLogout={this.props.doLogout}
        />
    }
    setActiveModal(activeModal) {
        activeModal = activeModal || null;
        let modalHistory = this.state.modalHistory ? [...this.state.modalHistory] : [];

        if (activeModal === null) {
            modalHistory = [];
        } else if (modalHistory.indexOf(activeModal) !== -1) {
            modalHistory = modalHistory.splice(0, modalHistory.indexOf(activeModal) + 1);
        } else {
            modalHistory.push(activeModal);
        }

        this.setState({
            activeModal,
            modalHistory
        });
    };

    receiveMessage = (event) => {

    }

    handleScroll() {

    }
    componentDidMount() {
        window.addEventListener('message', this.receiveMessage, false)
        window.addEventListener('scroll', this.handleScroll)

    }
    componentWillUnmount() {
        window.removeEventListener('message', this.receiveMessage, false)
        window.removeEventListener('scroll', this.handleScroll)

    }
}

export default BaseComponent